var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.delType === 'topic'
        ? 'f-icon-topic-delete' : 'f-icon-reply-delete',on:{"click":_vm.del}},[_c('img',{staticClass:"f-icon-delete-img",attrs:{"src":_vm.icon}}),_c('span',{staticClass:"f-icon-delete-word"},[_vm._v("删除")])])}
var staticRenderFns = []

export { render, staticRenderFns }